export function getUser() {
    return window.config.session_user;
}